import { Tab, Tabs } from '@mui/material';

import {
  PreFlightSource,
  convertPreFlightSource,
} from '../../../api/preFlight/enumerations';
import { Constants } from '../constants';

interface SourceTabsProps {
  value: PreFlightSource | '';
  onChange: (source: PreFlightSource | '') => void;
}

/**
 * Filtro por origem da solicitação.
 *
 * POR QUE UM FILTRO E NÃO SÓ O RÓTULO NO CARD
 *
 * O rótulo diz de onde UMA solicitação veio; ele não ajuda quem precisa varrer a fila de
 * uma origem só. E as duas origens não são o mesmo trabalho de revisão: a do Laudimob vem
 * de um cliente que contratou pelo site e traz os dados que ele preencheu; a do RPAM vem da
 * gestão de carteira, com o ativo já cadastrado do outro lado, um gestor esperando o laudo
 * voltar por integração, e campos que o revisor precisa completar antes de aprovar.
 *
 * POR QUE O FILTRO É DO SERVIDOR E NÃO DA LISTA JÁ CARREGADA
 *
 * A lista é paginada de 6 em 6. Filtrar o que já está na tela mostraria "nenhuma" sempre
 * que as seis primeiras fossem de outra origem — e o revisor concluiria que não há nada.
 *
 * AS ABAS SÃO FIXAS, E ISSO É UMA DÍVIDA DECLARADA
 *
 * As fontes vivem no `sources/registry.py` do backend, que não é exposto por endpoint
 * nenhum. Uma terceira fonte precisa de uma linha aqui. É o mesmo acoplamento do enum
 * `PreFlightSource`, e trocá-lo por uma rota de configuração é trabalho de outro escopo.
 */
export function SourceTabs({ value, onChange }: SourceTabsProps): JSX.Element {
  return (
    <Tabs
      value={value}
      onChange={(_, novaOrigem) => onChange(novaOrigem)}
      aria-label={Constants.sourceFilterLabel}
      sx={{ minHeight: 40, marginBottom: '16px' }}
    >
      <Tab label={Constants.allSourcesLabel} value="" sx={{ minHeight: 40 }} />
      <Tab
        label={convertPreFlightSource(PreFlightSource.SALES)}
        value={PreFlightSource.SALES}
        sx={{ minHeight: 40 }}
      />
      <Tab
        label={convertPreFlightSource(PreFlightSource.RPAM)}
        value={PreFlightSource.RPAM}
        sx={{ minHeight: 40 }}
      />
    </Tabs>
  );
}
